<template>
  <div class="content__area">
    <div class="container-fluid">
      <div class="content__wrapper">
        <div class="content__box"> <!---- restricted --->
          <div class="content__box__header">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                flex-wrap
              "
            >
              <div class="order-1">
                <p class="text-white txt--ss opacity--50 mb-1">Permits</p>
              </div>
              <div class="order-2 ml-5">
                <input
                  type="text"
                  placeholder="Search"
                  aria-label="Search"
                  class="input__field"
                  v-model="search"
                />
              </div>
              <!-- PROPERTY DROPDOWN -->
              <div
                class="
                  filterReport
                  mt-2 mt-sm-0
                  ml-0 ml-sm-5
                  order-3 order-sm-2
                "
              >
                <p class="txt--ss opacity--50 cursor-default">Property:</p>
                <div class="filter__dropdown ml-3" @mouseover="showDropDown()">
                  <p
                    class="txt--ss txt--primary cursor-pointer alignment-report"
                  >
                    {{
                      selected_property_name
                        ? selected_property_name
                        : "Select Property"
                    }}
                  </p>
                  <div
                    class="filter__items"
                    v-show="show_property_dropdown"
                    v-click-outside="closeDropdown"
                  >
                    <div class>
                      <input
                        type="text"
                        placeholder="Find property"
                        aria-label="Search"
                        class="input__field"
                        v-model="searchProperty"
                        @keyup="getAllProperty"
                      />
                      <div class="mt-3">
                        <div class="top__filter">
                          <ul class="top__filter__ul">
                            <li class="cursor-default">Property</li>
                          </ul>
                          <ul
                            class="top__filter__ul"
                            v-if="selected_property_id != ''"
                          >
                            <li
                              id="clear_filter_property"
                              @click="clearPropertyFilter()"
                            >
                              Clear {{ $t("Filter") }}
                            </li>
                            <!-- <li>None</li> -->
                          </ul>
                        </div>
                        <div
                          class="propertyFilters"
                          v-if="property_list.length > 0"
                        >
                          <p
                            class="
                              txt--primary txt--ss
                              my-3
                              txt--semi-bold
                              cursor-pointer
                            "
                            v-for="(p, index) in property_list"
                            :key="index"
                          >
                            <span
                              class="cursor-pointer property_item"
                              @click="getPermitsForProperty(p)"
                            >
                              {{
                                p.property_name != ""
                                  ? p.property_name
                                  : p.address.split(",")[0]
                              }}
                            </span>
                          </p>
                        </div>
                        <div
                          class="propertyFilters d-flex justify-content-center"
                          v-else
                        >
                          <p class="txt--primary txt--ss my-3 txt--semi-bold">
                            No Property Found
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center order-3 ml-auto">
                <p
                  class="txt--off-white txt--ss mb-1 cursor-pointer mr-3"
                  @click="openModal('permit-ivitations-list')"
                  v-if="invitation_access"
                >
                  Manage/Send Permit Invitations
                </p>
                <!-- OFFSTREET SYNCABLE FILTER -->
                <div class="d-flex align-items-center mr-3" v-if="showOffstreetUi">
                  <p class="txt--ss opacity--50 cursor-default mb-0 mr-2">Offstreet:</p>
                  <span
                    class="offstreet-filter-chip"
                    :class="{ active: offstreet_syncable_filter === null }"
                    @click="setOffstreetSyncableFilter(null)"
                  >All</span>
                  <span
                    class="offstreet-filter-chip"
                    :class="{ active: offstreet_syncable_filter === true }"
                    @click="setOffstreetSyncableFilter(true)"
                  >Syncable</span>
                  <span
                    class="offstreet-filter-chip"
                    :class="{ active: offstreet_syncable_filter === false }"
                    @click="setOffstreetSyncableFilter(false)"
                  >Not Syncable</span>
                </div>
                <p
                  v-if="showOffstreetUi && (user_role == 'commercial' || (user_role == 'operator' && access_lists && access_lists.permit_access_write == true))"
                  class="txt--off-white txt--ss mb-1 cursor-pointer mr-3"
                  @click="openOffstreetPropertyMapping"
                >
                  Offstreet Property Mapping
                </p>
                <p
                  v-if="user_role == 'commercial'"
                  class="txt--off-white txt--ss mb-1 cursor-pointer mr-3"
                  @click="openCustomIdentifierManager"
                >
                  Manage Custom Identifiers
                </p>
                <p
                  v-if="user_role == 'commercial' || (user_role == 'operator' && access_lists.permit_access_write == true)"
                  class="txt--off-white txt--ss mb-1 cursor-pointer"
                  @click="openModal('create-permit-modal')"
                >
                  + Create/Add Permit
                </p>
                <!-- <p
                  class="txt--off-white txt--ss mb-1 cursor-pointer"
                  @click="openModal('create-permit-modal')"
                >
                  + Create/Add Permit
                </p> -->
              </div>
            </div>
          </div>
          <div class="content__divider"></div>
          <div class="content__box__body content__box__body__audit__table">
            <div class="table-responsive">
              <input type="hidden" id="permitId" />
              <table class="table table__audit table-borderless">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Price</th>
                    <th>Permit Id</th>
                    <th>Price Id</th>
                    <th>Property</th>
                    <th>Duration</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Recurring</th>
                    <th>Active Subscriptions</th>
                    <th>Quantity</th>
                    <th>Availability</th>
                    <th>Status</th>
                    <th>Handle Method</th>
                    <th v-if="showOffstreetUi">Offstreet</th>
                    <th>Send Memos</th>
                    <th>Action</th>
                    <th>Custom Message</th>
                  </tr>
                </thead>
                <tbody v-if="permitLists.length > 0">
                  <tr
                    v-for="(permit, index) in permitLists"
                    :key="index"
                    style="cursor: default"
                  >
                    <td
                      @click="openUpdatePermitModal(permit)"
                      class="cursor-pointer"
                      v-tooltip="'Edit Permit'"
                    >
                      {{ permit.permit_name }}
                    </td>
                    <td>${{ permit.permit_price.toFixed(2) }}</td>
                    <td>
                      <p
                        title="click to copy"
                        class="cursor-pointer"
                        @click="copypermitId($event, permit.permit_id)"
                      >
                        {{ permit.permit_id }}
                      </p>
                    </td>
                    <td>
                      <p
                        title="click to copy"
                        class="cursor-pointer"
                        @click="copypermitId($event, permit.price_id)"
                      >
                        {{ permit.price_id }}
                      </p>
                    </td>
                    <td
                      @click="openPropertyDetails(permit.property_id)"
                      class="cursor-pointer"
                      v-tooltip="'Open property details'"
                    >
                      {{ permit.property_name }}
                    </td>
                    <td>
                      {{permit.flex_permit == 1 ? permit.available_parking_days+' days/' : ''}}
                      {{
                        permit.permit_duration +
                        " " +
                        permit.permit_duration_type
                      }}
                    </td>
                    <td>
                      <span v-if="permit.start_date !== ''">
                        {{ permit.start_date | formatDate }}
                      </span>
                      <span v-else>-</span>
                    </td>
                    <td>
                      <span v-if="permit.end_date !== ''">
                        {{ permit.end_date | formatDate }}
                      </span>
                      <span v-else>-</span>
                    </td>
                    <td>
                      {{ permit.recurring === 1 ? (permit.flex_permit==1 ? "Flex Recurring" : "Recurring") : "One Time" }}
                    </td>
                    <td>{{permit.subscribers}}</td>
                    <td>
                      {{ permit.quantity_unlimited == 1 ? 'Unlimited' : permit.permit_quantity }}
                    </td>
                    <td>
                      {{ permit.public_permit === 1 ? "Public" : "Private" }}
                    </td>
                    <td>
                      <span
                        v-if="user_role == 'commercial' || (user_role == 'operator' && access_lists.permit_access_write == true)"
                        @click="
                          changePermitStatus(permit.permit_id, permit.active)
                        "
                        class="cursor-pointer"
                        :class="{
                          'txt--green': permit.active === 1,
                          'txt--red': permit.active === 0,
                        }"
                      >
                        {{ permit.active === 1 ? "Active" : "Inactive" }}
                      </span>
                      <span
                        v-else
                        :class="{
                          'txt--green': permit.active === 1,
                          'txt--red': permit.active === 0,
                        }"
                      >
                        {{ permit.active === 1 ? "Active" : "Inactive" }}
                      </span>
                    </td>
                    <td>
                      {{
                        permit.handle_method.charAt(0).toUpperCase() +
                        permit.handle_method.slice(1)
                      }}
                    </td>
                    <td v-if="showOffstreetUi">
                      <p class="mb-0 txt--ss">
                        {{ getOffstreetSummary(permit).effectiveLocation || "Not mapped" }}
                      </p>
                      <p class="mb-0 txt--xs offstreet-source-chip" :class="'source-' + getOffstreetSummary(permit).source">
                        {{ getOffstreetSummary(permit).sourceLabel }}
                      </p>
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span
                          class="cursor-pointer"
                          @click="openSendPermitMemoModal(permit)"
                        >
                          Send
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        <!-- <span
                          class="cursor-pointer txt--red mr-2"
                          @click="deletePermit(permit.permit_id)"
                        >
                          Delete
                        </span> -->
                        <span
                          class="cursor-pointer"
                          @click="openUpdatePermitModal(permit)"
                        >
                          Edit
                        </span>
                        <span
                          class="cursor-pointer ml-2 txt--primary"
                          v-if="showOffstreetUi && (user_role == 'commercial' || (user_role == 'operator' && access_lists && access_lists.permit_access_write == true))"
                          @click="openOffstreetPermitModal(permit)"
                        >
                          Offstreet
                        </span>
                      </div>
                    </td>
                    <td>
                      <span
                        class="cursor-pointer txt--orange"
                        @click="openCustomMessageModal(permit)"
                      >
                         {{ permit.permit_custom_message !='' ? "Edit" : "Add" }}
                      </span>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="cursor-default">
                    <td :colspan="showOffstreetUi ? 18 : 17">
                      <p class="text-center">No Data Found</p>
                    </td>
                  </tr>
                </tbody>
              </table>

              <infinite-loading
                @infinite="paginate"
                :distance="10"
                force-use-infinite-wrapper=".content__box__body.content__box__body__audit__table"
                v-if="permitLists.length > 0 && permitPagination.load_more"
              >
                <div slot="spinner">
                  <div class="d-flex justify-content-center mt-4">
                    <div class="lds-ring">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
                <div slot="no-more"></div>
                <div slot="no-results">No data found</div>
              </infinite-loading>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CreatePermit @update_list="refresh"></CreatePermit>
    <UpdatePermit @update_list="refresh" />
    <PermitInvitationsList
      @permit-status="openPermitDetailsModal($event)"
      @send-application="openSendPermitModal($event)"
      :access_lists="this.access_lists"
    />
    <PermitCustomMessage @update_list="refresh"></PermitCustomMessage>
    <EditPermit @update_list="refresh"/>
    <SendPermitMemos @update_list="refresh"/>
    <OffstreetPermitManagement />
    <OffstreetPropertyMapping />
    <PermitCustomer />
    <CustomIdentifierManager @updated="refresh" />
  </div>
</template>
<script>
import CreatePermit from "@/components/modals/CreatePermit";
import CustomIdentifierManager from "@/components/modals/CustomIdentifierManager";
import UpdatePermit from "@/components/modals/PermitUpdate";
import EditPermit from "@/components/modals/EditPermit";
import OffstreetPermitManagement from "@/components/modals/OffstreetPermitManagement";
import OffstreetPropertyMapping from "@/components/modals/OffstreetPropertyMapping";
import PermitCustomer from "@/components/modals/PermitCustomer";
import SendPermitMemos from "@/components/modals/SendPermitMemos";
import PermitInvitationsList from "@/components/modals/PermitInvitations";
import commonservices from "../../services/CommonService";
import PermitCustomMessage from '../../components/modals/PermitCustomMessage.vue';
const service = new commonservices();
export default {
  name: "PermitList",
  components: {
    CreatePermit,
    CustomIdentifierManager,
    UpdatePermit,
    PermitInvitationsList,
    PermitCustomMessage,
    EditPermit,
    OffstreetPermitManagement,
    OffstreetPropertyMapping,
    PermitCustomer,
    SendPermitMemos,
  },
  data() {
    return {
      user:{},
      property_id_list:[],
      invitation_access: true,
      permit_source: null,
      search: "",
      show_property_dropdown: false,
      property_list: [],
      searchProperty: "",
      selected_property_name: "",
      selected_property_id: "",
      offstreet_syncable_filter: null,
      permitLists: [],
      permitPagination: {
        page: 1,
        load_more: true,
        infiniteId: +new Date(),
        to: 0,
        total: 0,
      },
      access_lists: null,
      user_role:    '',
    };
  },
  directives: {
    "click-outside": {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }

          // console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener("click", handler);
      },

      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
        // console.log(binding);
      },
    },
  },
  watch: {
    search: function (newVal, oldVal) {
      if (newVal.trim() != oldVal.trim()) {
        this.permitLists = [];
        this.permitPagination.page = 1;
        this.getPermits();
      }
    },
    searchProperty: function (newVal, oldVal) {
      if (newVal.trim() != oldVal.trim()) {
        this.searchPermitsProperty();
      }
    },
  },
  computed: {
    showOffstreetUi() {
      const offstreetEnabled = ["true", "1"].includes(
        String(localStorage.getItem("offstreet_integration_enabled") || "").toLowerCase()
      );

      if (!offstreetEnabled) {
        return false;
      }

      return this.user_role === "commercial";
    },
  },
  created() { 
    this.user_role            = localStorage.getItem('role');
    let user_role             = localStorage.getItem("role");
    let property_access_list  = localStorage.getItem("commercial_access_list");
    property_access_list      = JSON.parse(property_access_list) || {};
    if(user_role == "operator"){
      if(Object.keys(property_access_list).length>0){
        this.property_id_list=property_access_list.property_access_list;
        this.access_lists     = JSON.parse(localStorage.getItem("commercial_access_list"));
      }
    }       
    this.getPermits();
    this.getAllProperty();
    let access_list = localStorage.getItem("commercial_access_list");
    access_list = JSON.parse(access_list) || {};
    if(Object.keys(access_list).length>0) {
      this.invitation_access = access_list.invitation_access;     
    }
  },
  methods: {
    showDropDown() {
      this.show_property_dropdown = true;
    },
    preventClose(e) {
      if (
        e.target.id == "clear_filter_property" ||
        e.target.classList.contains("property_item")
      ) {
        return;
      }
      e.stopPropagation();
    },
    closeDropdown() {
      this.show_property_dropdown = false;
    },
    openSendPermitModal(payload) {
      if (payload) {
        this.$modal.show("send-permit-ivitations");
      }
    },
    openPermitDetailsModal(payload) {
      if (payload) {
        this.$modal.show("permit-invitation-details");
      }
    },
    getPermitsForProperty(property) {
      this.selected_property_name = property.property_name;
      this.selected_property_id = property.space_id;
      this.permitPagination.page = 1;
      this.permitPagination.load_more = false;
      this.permitPagination.total = 0;
      this.permitPagination.to = 0;
      this.permitPagination.page_count = 0;
      this.getPermits();
    },
    getPermits() {           
      if (this.permit_source) {
        this.permit_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.permit_source = CancelToken.source();
      this.axios
        .post(
          window.hostname + "/api/auth/permit/list",
          {
            commercial: 1,
            page: this.permitPagination.page,
            search: this.search,
            property_id: this.selected_property_id,
            property_id_list:this.property_id_list,
            ...(this.showOffstreetUi && this.offstreet_syncable_filter !== null ? { offstreet_syncable: this.offstreet_syncable_filter } : {}),
          },
          {
            cancelToken: this.permit_source.token,
          }
        )
        .then((res) => {
          if (res.data.status && Object.keys(res.data.data).length > 0 ) {
            this.permitLists = res.data.data.permit_list;
            // console.log(this.permitLists.length);
            // console.log(res.data.data.permit_list);
            this.permitPagination.page = res.data.data.pagination.page;
            this.permitPagination.load_more =
              res.data.data.pagination.load_more == 1 ? true : false;
            this.permitPagination.to = res.data.data.pagination.to;
            this.permitPagination.total = res.data.data.pagination.total;
          } else {
            this.permitPagination.page = 1;
            this.permitPagination.load_more = false;
            this.permitPagination.total = 0;
            this.permitPagination.to = 0;
            this.permitLists = [];
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    searchPermitsProperty() {
      this.permitPagination.page = 1;
      this.permitPagination.load_more = false;
      this.permitPagination.total = 0;
      this.permitPagination.to = 0;
      this.permitPagination.page_count = 0;
      this.getAllProperty();
    },
    searchPermit() {
      this.permitLists = [];
      this.permitPagination.page = 1;
      this.getPermits();
    },
    async getAllProperty() {
      let property_response = await service.getAllProperty(this.searchProperty);
      if (property_response.status == 200) {
        if (property_response.data.status) {
          this.property_list = property_response.data.data.all_space;
        } else {
          this.property_list = [];
        }
      } else {
        this.$toasted.show("Something went wrong. Please try again!", {
          icon: "timex-circle",
          className: "error-class",
        });
      }
    },
    clearPropertyFilter() {
      this.searchProperty = "";
      this.selected_property_name = "";
      this.selected_property_id = "";
      this.permitPagination.page = 1;
      this.permitLists = [];
      this.getPermits();
    },
    setOffstreetSyncableFilter(value) {
      if (!this.showOffstreetUi) {
        return;
      }
      this.offstreet_syncable_filter = value;
      this.permitPagination.page = 1;
      this.permitLists = [];
      this.getPermits();
    },
    paginate($state) {
      this.axios
        .post(window.hostname + "/api/auth/permit/list", {
          commercial: 1,
          search: this.search,
          property_id: this.selected_property_id,
          page: this.permitPagination.page,
          property_id_list:this.property_id_list,
          ...(this.showOffstreetUi && this.offstreet_syncable_filter !== null ? { offstreet_syncable: this.offstreet_syncable_filter } : {}),
        })
        .then((res) => {
          if (res.data.status) {
            let permitLists = res.data.data.permit_list;
            permitLists.map((val) => {
              this.permitLists.push(val);
            });
          } else {
            this.permitLists = [];
          }

          this.permitPagination.page = res.data.data.pagination.page;
          this.permitPagination.load_more =
            res.data.data.pagination.load_more == 1 ? true : false;
          this.permitPagination.to = res.data.data.pagination.to;
          this.permitPagination.total = res.data.data.pagination.total;

          if (!this.permitPagination.load_more) {
            $state.loaded();
            $state.complete();
          } else {
            $state.loaded();
          }
        })
        .catch((err) => {
          $state.complete();
          // console.log(err);
        });
    },
    refresh() {
      this.permitPagination.page = 1;
      this.permitPagination.load_more = false;
      this.permitLists = [];
      this.getPermits();
    },
    openModal(modalName) {
      this.$modal.show(modalName);
    },
    openCustomIdentifierManager() {
      this.$modal.show("custom-identifier-manager", {
        propertyId: this.selected_property_id,
        propertyName: this.selected_property_name,
      });
    },
    getOffstreetSummary(permit) {
      const offstreet = permit && permit.offstreet ? permit.offstreet : {};
      const source = String(
        permit.offstreet_location_source || offstreet.location_source || "none"
      ).toLowerCase();
      const effectiveLocation =
        permit.offstreet_effective_location_id ||
        offstreet.effective_location_id ||
        permit.offstreet_location_id ||
        offstreet.location_id ||
        null;

      let sourceLabel = "Source: none";
      if (source === "permit") {
        sourceLabel = "Source: permit";
      } else if (source === "property") {
        sourceLabel = "Source: property";
      }

      return {
        source,
        sourceLabel,
        effectiveLocation,
      };
    },
    copypermitId(e, id) {
      let testingCodeToCopy = document.querySelector("#permitId");
      testingCodeToCopy.setAttribute("type", "text"); // 不是 hidden 才能複製
      testingCodeToCopy.setAttribute("value", id);
      testingCodeToCopy.select();

      try {
        var successful = document.execCommand("copy");
        if (successful) {
          this.$toasted.show("Copied text!", {
            icon: "check-circle",
            className: "success-class",
          });
        }
      } catch (err) {
        this.$toasted.show("Oops! unable to copy.", {
          icon: "times-circle",
          className: "error-class",
        });
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    changePermitStatus(permitId, status) {
      const statusChangeTo = status === 0 ? 1 : 0;
      const vm = this;
      let message = "Do you want to change the permit status?";
      const self = this;
      this.$swal({
        title: "Are you sure?",
        text: message,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.axios
            .post(window.hostname + "/api/auth/permit/update", {
              permit_id: permitId,
              active: statusChangeTo,
            })
            .then((res) => {
              if (res.data.status) {
                this.$toasted.show(res.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });
                vm.refresh();
              }
            })
            .catch((err) => {
              // console.log(err);
            });
        }
      });
    },
    openUpdatePermitModal(permit) {
      this.$modal.show("edit-permit", {
        permit: JSON.parse(JSON.stringify(permit)),
      });
    },
    openOffstreetPermitModal(permit) {
      if (!this.showOffstreetUi) {
        return;
      }
      this.$modal.show("offstreet-permit-management", {
        permit: JSON.parse(JSON.stringify(permit)),
      });
    },
    openOffstreetPropertyMapping() {
      if (!this.showOffstreetUi) {
        return;
      }
      this.$modal.show("offstreet-property-mapping", {
        selected_property_id: this.selected_property_id,
      });
    },
    openSendPermitMemoModal(permit) {
      this.$modal.show("send-permit-memos", {
        permit: JSON.parse(JSON.stringify(permit)),
      });
    },
    deletePermit(permit_id) {
      this.$swal({
        title: "Are you sure?",
        text: "Do you want to delete this permit?",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.axios
            .post(window.hostname + "api/auth/permit/delete", {
              permit_id: permit_id,
            })
            .then((res) => {
              if (res.data.status) {
                this.$toasted.show(res.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });
                this.refresh();
              } else {
                this.$toasted.show(res.data.message, {
                  icon: "times-circle",
                  className: "error-class",
                });
                return;
              }
            })
            .catch((err) => {
              this.$toasted.show(err.response.data.message, {
                icon: "times-circle",
                className: "error-class",
              });
            });
        }
      });
    },
    openCustomMessageModal(permit){
        this.$modal.show("permit-custom-message", {
        permit: JSON.parse(JSON.stringify(permit)),
      });
    },

    openPropertyDetails(property_id) {
      const url = this.$router.resolve({
        name: "Property",
        query: { p: property_id }
      }).href;

      window.open(url, '_blank');
    },
  },
};
</script>

<style>
/* style the background and the text color of the input ... */
.vue-tags-input {
  border-radius: 16px !important;
  background: transparent !important;
  font-size: 12px !important;
  padding: 0 0.6rem !important;
  border: 1px solid hsla(0, 0%, 100%, 0.25) !important;
  max-width: 100% !important;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  color: hsla(0, 0%, 100%, 0.5);
}
.vue-tags-input.ti-focus {
  border-color: #f5a621 !important;
}

.vue-tags-input .ti-new-tag-input {
  background: transparent !important;
  color: #b7c4c9;
}

.ti-input {
  border: 0 !important;
  padding: 4px 10px;
  transition: border-bottom 200ms ease;
}

/* we cange the border color if the user focuses the input */
.vue-tags-input.ti-focus .ti-input {
  border: 1px solid #ebde6e;
}

/* some stylings for the autocomplete layer */
.vue-tags-input .ti-autocomplete {
  background: #191919 !important;
  border: 0 !important;
  border-top: none !important;
  border-radius: 10px !important;
  width: 148px !important;
  top: 35px !important;
  padding-top: 10px !important;
}

/* the selected item in the autocomplete layer, should be highlighted */
.vue-tags-input .ti-item {
  color: #fff;
}
.vue-tags-input .ti-item.ti-selected-item {
  background-color: transparent;
}

/* style the placeholders color across all browser */
.vue-tags-input ::-webkit-input-placeholder {
  color: #a4b1b6;
}

.vue-tags-input ::-moz-placeholder {
  color: #a4b1b6;
}

.vue-tags-input :-ms-input-placeholder {
  color: #a4b1b6;
}

.vue-tags-input :-moz-placeholder {
  color: #a4b1b6;
}

/* default styles for all the tags */
.vue-tags-input .ti-tag {
  position: relative !important;
  background: transparent !important;
  color: #fff !important;
  align-items: center !important;
}

/* the styles if a tag is invalid */
.vue-tags-input .ti-tag.ti-invalid {
  background-color: #e88a74;
}

/* if the user input is invalid, the input color should be red */
.vue-tags-input .ti-new-tag-input.ti-invalid {
  color: #e88a74;
}

/* if a tag or the user input is a duplicate, it should be crossed out */
.vue-tags-input .ti-duplicate span,
.vue-tags-input .ti-new-tag-input.ti-duplicate {
  text-decoration: line-through;
}

/* if the user presses backspace, the complete tag should be crossed out, to mark it for deletion */
.vue-tags-input .ti-tag:after {
  transition: transform 0.2s;
  position: absolute;
  content: "";
  height: 2px;
  width: 108%;
  left: -4%;
  top: calc(50% - 1px);
  background-color: #000;
  transform: scaleX(0);
}

.vue-tags-input .ti-deletion-mark:after {
  transform: scaleX(1);
}
.ti-tag .ti-actions {
  background-color: rgba(255, 255, 255, 0.2) !important;
  font-size: 8px !important;
  justify-content: center !important;
  width: 13px !important;
  height: 13px !important;
  border-radius: 100% !important;
  color: rgba(255, 255, 255, 0.25) !important;
}
.date-range-time-class-audit .date__range__input .field.is-dark .field-input {
  width: 150px;
  padding: 0 10px;
}
.date-range-time-class-audit .time-picker::after,
.date-range-time-class-audit .time-picker::before {
  border-top: 0;
  border-bottom: 0;
}

@media (max-width: 460px) {
  .date-range-time-class-audit {
    flex-direction: column;
  }
  .date-range-time-class-audit .separator {
    display: none;
  }
  .date-range-time-class-audit .date__range__input {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}
</style>

<style scoped>
.offstreet-filter-chip {
  font-size: 11px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 3px 10px;
  margin-right: 6px;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}
.offstreet-filter-chip:hover {
  border-color: rgba(255, 255, 255, 0.45);
  color: rgba(255, 255, 255, 0.85);
}
.offstreet-filter-chip.active {
  background: rgba(24, 154, 255, 0.15);
  border-color: rgba(24, 154, 255, 0.55);
  color: #189aff;
}
</style>